import { defineMessages } from 'react-intl-next';

export default defineMessages({
    clearConversationButton: {
        defaultMessage: 'Clear conversation',
        description: 'Button to clear current conversation in AI answers.',
        id: 'help-center.conversation.clear.conversation.button',
    },
});
